import styled from 'styled-components';
import { H6 } from '@finect/tabular-core/Headings';
export var SectionTitle = styled(H6).withConfig({
  displayName: "SectionTitle",
  componentId: "sc-1rb9xx5-0"
})(["font-weight:500;font-variant:small-caps;color:", ";text-transform:lowercase;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondary;
});